export enum EventTypes {
  BerthUpsertedEvent = 'BerthUpsertedEvent',
  BerthDeletedEvent = 'BerthDeletedEvent',
  ContainerEventsUpsertedEvent = 'ContainerEventsUpsertedEvent',
  ContainerUpsertedEvent = 'ContainerUpsertedEvent',
  ContainerJourneysUpsertedEvent = 'ContainerJourneysUpsertedEvent',
  FeatureFlagDeleted = 'FeatureFlagDeletedEvent',
  FeatureFlagUpserted = 'FeatureFlagUpsertedEvent',
  NonNumericOrderUpsertedEvent = 'NonNumericOrderUpsertedEvent',
  NonNumericOrderDeletedEvent = 'NonNumericOrderDeletedEvent',
  NumericReleaseUpsertedEvent = 'NumericReleaseUpsertedEvent',
  NumericReleasesDeletedEvent = 'NumericReleasesDeletedEvent',
  OrdersDeletedEvent = 'OrdersDeletedEvent',
  OrdersUpsertedEvent = 'OrdersUpsertedEvent',
  ReleaseOrdersUpsertedEvent = 'ReleaseOrdersUpsertedEvent',
  TenantUpsertedEvent = 'TenantUpsertedEvent',
  TruckDeletedEvent = 'TruckDeletedEvent',
  TruckUpsertedEvent = 'TruckUpsertedEvent',
  TruckVisitUpsertedEvent = 'TruckVisitUpsertedEvent',
  TruckVisitDeletedEvent = 'TruckVisitDeletedEvent',
  VesselDeletedEvent = 'VesselDeletedEvent',
  VesselUpsertedEvent = 'VesselUpsertedEvent',
  VesselVisitCreated = 'VesselVisitCreated',
  CarrierVisitDeleted = 'CarrierVisitDeleted',
  VesselVisitUpdated = 'VesselVisitUpdated',
  CarrierVisitConflictUpdated = 'CarrierVisitConflictUpdated',
  RailVisitCreated = 'RailVisitCreated',
  RailVisitDeleted = 'RailVisitDeleted',
  RailVisitUpdated = 'RailVisitUpdated',
  PackageUpserted = 'PackageUpserted',
  PackageDeleted = 'PackageDeleted',
  RailTrackUpsertedEvent = 'RailTrackUpsertedEvent',
  RailTrackDeletedEvent = 'RailTrackDeletedEvent',
  RailcarTrackPositionUpsertedEvent = 'RailcarTrackPositionUpsertedEvent',
  RailcarTrackPositionDeletedEvent = 'RailcarTrackPositionDeletedEvent',
  RailcarDeletedEvent = 'RailcarDeletedEvent',
  RailcarUpsertedEvent = 'RailcarUpsertedEvent',
  IssueUpsertedEvent = 'IssueUpsertedEvent',
  OrderUpdatesUpsertedEvent = 'OrderUpdatesUpsertedEvent',
  RemainOnBoardUnitsUpsertedEvent = 'RemainOnBoardUnitsUpsertedEvent',
  RemainOnBoardUnitsDeletedEvent = 'RemainOnBoardUnitsDeletedEvent',
  VesselServiceDeletedInternalEvent = 'VesselServiceDeletedInternalEvent',
  VesselServiceUpsertedInternalEvent = 'VesselServiceUpsertedInternalEvent',
  ExternalDriverDeletedInternalEvent = 'ExternalDriverDeletedInternalEvent',
  ExternalDriverUpsertedInternalEvent = 'ExternalDriverUpsertedInternalEvent',
  CompanyUpsertedInternalEvent = 'CompanyUpsertedInternalEvent',
  CompanyDeletedInternalEvent = 'CompanyDeletedInternalEvent',
  WeightClassUpsertedInternalEvent = 'WeightClassUpsertedInternalEvent',
  WeightClassDeletedInternalEvent = 'WeightClassDeletedInternalEvent',
  WeightClassUpsertedEvent = 'WeightClassUpsertedEvent',
  WeightClassDeletedEvent = 'WeightClassDeletedEvent',
  HoldUpsertedInternalEvent = 'HoldUpsertedInternalEvent',
  GateUpsertedEvent = 'GateUpsertedEvent',
  GateDeletedEvent = 'GateDeletedEvent',
}
